import { render, staticRenderFns } from "./CombinationOptionList.vue?vue&type=template&id=6c853d1a&"
import script from "./CombinationOptionList.vue?vue&type=script&lang=ts&"
export * from "./CombinationOptionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports